import React, { useCallback, useState } from "react";
import jwtDecode from "jwt-decode";
import { post } from "../server/api.js";
import Translator from "./translator";
import SessionKeys from "../session";
import "../../css/profile-page.css";

const erreurMotDePasseCourt = "* Ce mot de passe est trop court";
const erreurMotsDePassesDifferents = "* Doit être identique à votre mot de passe";

/**
 * Écran obligatoire après connexion avec mot de passe temporaire (réinitialisation).
 */
function ProfileMandatoryPasswordPanel({
  language,
  idZec,
  authToken,
  setAlert,
  showOverlay,
  hideOverlay,
  onCompleted,
}) {
  const TEXTS = Translator(language, "TXT_PROFILE_PAGE");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const submit = useCallback(() => {
    const np = (newPassword || "").trim();
    const npc = (confirmPassword || "").trim();
    if (!np || !npc) {
      setAlert(TEXTS.error0, "danger");
      return;
    }
    if (np.length < 4) {
      setAlert(erreurMotDePasseCourt, "danger");
      return;
    }
    if (np !== npc) {
      setAlert(erreurMotsDePassesDifferents, "danger");
      return;
    }

    showOverlay("PROFILE_PASSWORD_RESET");

    post(
      "/" + idZec + "/Utilisateur/CompletePasswordReset",
      JSON.stringify({ newPassword: np, confirmPassword: npc }),
      {
        convertToJson: false,
        authToken: authToken,
        acceptLanguage: language,
      }
    )
      .then((result) => {
        if (result.status === 200) {
          return result.json().then((body) => {
            if (!body || !body.success)
              throw new Error(TEXTS.forgotErrorGeneric);
            return body;
          });
        }
        return result
          .json()
          .then((j) => {
            throw new Error(j.error || TEXTS.forgotErrorGeneric);
          })
          .catch(() => {
            throw new Error(TEXTS.forgotErrorGeneric);
          });
      })
      .then(() => {
        sessionStorage.removeItem(SessionKeys.MUST_CHANGE_PASSWORD);
        setNewPassword("");
        setConfirmPassword("");
        setAlert(TEXTS.mandatoryPasswordSaved, "success");
        if (onCompleted) {
          const { idProfile } = jwtDecode(authToken);
          onCompleted(idProfile);
        }
      })
      .catch((e) => {
        if (e.name !== "AbortError")
          setAlert(e.message, "danger");
      })
      .finally(() => {
        hideOverlay("PROFILE_PASSWORD_RESET");
      });
  }, [
    newPassword,
    confirmPassword,
    idZec,
    authToken,
    language,
    TEXTS,
    setAlert,
    showOverlay,
    hideOverlay,
    onCompleted,
  ]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        submit();
      }
    },
    [submit]
  );

  return (
    <div id="profile-page" className="profile-div">
      <div className="display-inline-block" style={{ maxWidth: "32rem" }}>
        <div className="profile-div profile-label-wrapper-title profile-signup-form-title">
          <span className="profile-span">{TEXTS.requisNouveauMotDePasse}</span>
        </div>
        <div className="profile-div">
          <span className="profile-span" style={{ display: "block", textAlign: "left" }}>
            {TEXTS.textMandatoryPasswordIntro}
          </span>
        </div>
        <div>
          <div className="profile-label-wrapper">
            <span className="profile-span">{TEXTS.password}</span>
          </div>
          <div className="input-container">
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              onKeyDown={onKeyDown}
              className="profile-input"
              autoComplete="new-password"
            />
          </div>
        </div>
        <div>
          <div className="profile-label-wrapper">
            <span className="profile-span">{TEXTS.confirmPassword}</span>
          </div>
          <div className="input-container">
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onKeyDown={onKeyDown}
              className="profile-input"
              autoComplete="new-password"
            />
          </div>
        </div>
        <div className="profile-div">
          <div className="profile-div btn-login clickable" onClick={() => submit()}>
            <span className="profile-span">{TEXTS.btnMandatoryPasswordConfirm}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileMandatoryPasswordPanel;
